import { AxiosResponse, AxiosError } from "axios";
import { prepareError } from "../../../utils/error";
import api from "../../../data/api";
import { OptionCl } from "../../../components/select-cl";
import { Dispatch } from "redux";


export const DEPO_CITY_DOMAIN = "DCITY"

export type DepoCity = {
    city: string
}

const prepareDepoCities  = ( response : DepoCity[]   ) => {
    const opts: OptionCl[] = response.map( (dCity : DepoCity) => ({
        id : dCity.city,
        description: dCity.city
    })
    )
    return opts;
}


// depository cities for the depository dropdown
export const fetchDepoCities = (
    dispatch : Dispatch<any>,
    componentType: "DepositoryCriteria"
) => {
    api
        .post("/codelist/v1/Depository/depcities")
        .then( (response:AxiosResponse) => {            
            if (response.data && response.data.result === "ERROR") {
                dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(response.data) })
            } else { 
                const depoCities : DepoCity[] = response.data.Depository; 
                dispatch({type: componentType + "/DOMAINLOADED", payload: prepareDepoCities(depoCities), domain: DEPO_CITY_DOMAIN })
            }
        }).catch( (error:AxiosError) => {
            dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(error) })
        })

}
